<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4>Item Master </h4>
          </div>

          <div class="card-body">
            <form [formGroup]="ItemMasterForm">
              <div class="cardSearch2">
                <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseExample" (click)="showhideAdd()" role="button"
                aria-expanded="false" aria-controls="collapseExample">
                <header class="panel-heading">
                    <h5 class="panel-title">Add Item (Tap to Expand)</h5>
                </header>
            </div>
            <div *ngIf="IsAddpanelshow" id="collapseExample">
              <div class="card-body2">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>SubCategory Name</label></div>
                    <div class="col-md-7">
                      <p-dropdown [options]="subcategoryList" optionLabel="SubCategoryName" placeholder="--Select--" formControlName="SelectedsubCategory"
                      filter="true" [showClear]="true">
                    </p-dropdown>
                    <mat-error
                    *ngIf="GetFormControls('SelectedsubCategory').invalid && (GetFormControls('SelectedsubCategory').dirty || GetFormControls('SelectedsubCategory').touched)"
                    class="ValidationError">
                    <mat-error *ngIf="GetFormControls('SelectedsubCategory').errors.required">
                      SubCategory Name is required.
                    </mat-error>
                  </mat-error>   
                  </div>
                  <div class="col-md-1"></div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Item Name</label></div>
           
                      <div class="col-md-8">   <input class="form-control" maxlength="50"  formControlName="ItemName">
                     
                        <mat-error
                        *ngIf="GetFormControls('ItemName').invalid && (GetFormControls('ItemName').dirty || GetFormControls('ItemName').touched)"
                        class="ValidationError">
                        <mat-error *ngIf="GetFormControls('ItemName').errors.required">
                          Item Name is required.
                        </mat-error>
                      </mat-error>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <br>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="row">
                        <div class="col-md-4"> <label>Status</label></div>
                        <div class="col-md-8">
                          <div class="col-md-8">
                            <input type="checkbox" class="checkbox_size" formControlName="IsActive" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-8" style="text-align: center;">
                      <button type="submit" class="btn-primary1" (click)="submitdata()" >Submit</button>
                      <button class="btn-primary1" (click)="Export()">Export as Excel</button>

                    </div>
                   
                    
                  </div>
                  
                </div>
              </div>
            </div>
              </div>
                <div class="clearfix"></div>

                <div class="cardSearch2">
                  <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseSearch" (click)="showhide()" role="button"
                      aria-expanded="false" aria-controls="collapseSearch">
                      <header class="panel-heading">
                          <h5 class="panel-title">Search(Tap to Expand)</h5>
                      </header>
                  </div>
                  <div *ngIf="Ispanelshow" id="collapseSearch">
                      <div class="card-body2">
                          <div class="row">
                              <div class="form-group2 col-md-6">
                                  <label class="required">SubCategory Name</label>
                                  <p-dropdown [options]="subcategoryList" optionLabel="SubCategoryName" placeholder="--Select--" formControlName="SubCategorySearch"
                                  filter="true" [showClear]="true">
                                </p-dropdown>
                              </div>
                              <div class="form-group2 col-md-6">
                                  <label class="required">Status</label>
                                  <p-dropdown [options]="statusList" optionLabel="StatusName" placeholder="--Select--" formControlName="StatusSearch"
                                  filter="true" [showClear]="true">
                                </p-dropdown>
                              </div>
                          </div>
                          
                          <div class="clearfix"></div>
                        <div class="row">
        
                          <div class="col-md-12" style="text-align: center;">
                            <button class="btn-primary1" (click)="Exit()">Exit</button>
                            <button class="btn-primary1" (click)="ResetData()">Reset</button>
                            <button type="submit" style="margin-top: 10px;margin-right: 80px;" value="Submit" class="btn-primary1" (click)="GetResult()" >Get Result</button>
                            
        
                          </div>
                          
                        </div>
                      </div>
                  </div>
              </div>
              <div class="clearfix"></div>
                <div class="row">
                 
                <div class="col-md-12">
                 
                  <div class="mat-elevation-z8 top-margin-border" #TABLE>
          <table mat-table [dataSource]="ItemDataSource" #table style="width:100% !important">
  
            <ng-container matColumnDef="ItemId" >
              <th mat-header-cell *matHeaderCellDef> Item ID </th>
              <td mat-cell *matCellDef="let element" style="cursor:pointer;color:blue; text-decoration: underline;"> {{element.ItemId}} </td>
            </ng-container>
                        
            <ng-container matColumnDef="ItemName">
              <th mat-header-cell *matHeaderCellDef> Item Name </th>
              <td mat-cell *matCellDef="let element"> {{element.ItemName}} </td>
            </ng-container>
  
            <ng-container matColumnDef="SubCategoryId">
              <th mat-header-cell *matHeaderCellDef> SubCategory ID </th>
              <td mat-cell *matCellDef="let element"> {{element.SubCategoryId}} </td>
            </ng-container>
  
            <ng-container matColumnDef="SubCategoryName">
              <th mat-header-cell *matHeaderCellDef> SubCategory Name </th>
              <td mat-cell *matCellDef="let element"> {{element.SubCategoryName}} </td>
            </ng-container>

            <ng-container matColumnDef="IsActive">
              <th mat-header-cell *matHeaderCellDef> IsActive </th>
              <td mat-cell *matCellDef="let element"> {{element.IsActive}} </td>
            </ng-container>

            <ng-container matColumnDef="Status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let element"> {{element.Status}} </td>
            </ng-container>

            <ng-container matColumnDef="Edit">
              <th mat-header-cell *matHeaderCellDef> Action </th>
              <td mat-cell *matCellDef="let element;  let j = index;" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="rowclickdata(element.ItemId)"> Edit </td>
            </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator  #paginator
          [length]="_global.length"
          [pageIndex]="_global.pageIndex"
          [pageSize]="_global.RecordSize"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="onPaginateChange1($event)"></mat-paginator>
        </div>
              </div>
              
              
                </div>
             
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>